import DownloadIcon from "@mui/icons-material/Download";
import LoadingButton from "@mui/lab/LoadingButton";
import React, {useState} from "react";
import axios from "axios";
import {ApiUrl} from "../../auth/authMethods";


export default function DownloadBoleto({boletoId, filename, disabled = false}) {

    const baseUrl = `${ApiUrl}/boletos`
    const [loading, setLoading] = useState(false)

    function downloadBoleto() {
        const url = baseUrl + '/generate/' + boletoId

        setLoading(true)
        axios.post(url, {}, {responseType: 'arraybuffer'})
            .then(response => {
                // Cria um objeto Blob a partir do array de bytes recebido na resposta
                const blob = new Blob([response.data], {type: 'application/octet-stream'});

                // Cria um link temporário para o Blob e o adiciona ao documento
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename ? filename + '.pdf' : 'boleto.pdf'; // Define o nome do arquivo a ser baixado
                document.body.appendChild(link);

                // Simula um clique no link para iniciar o download
                link.click();

                // Remove o link temporário do documento
                document.body.removeChild(link);
            })
            .catch(error => console.error('Erro ao gerar boleto:', error))
            .finally(() => {
                setLoading(false)
            })
    }

    return <LoadingButton
        title='Fazer download do boleto'
        loading={loading}
        onClick={() => downloadBoleto()}
        variant="text"
        disabled={disabled}
    >
        <DownloadIcon/>
    </LoadingButton>
}